import styled from 'styled-components';
import { styled as styledMUI } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { colorWhite, colorCobalt, logoColor3 } from '../../layout/css/colors';


const fontFamily = 'Avenir Next';

export const StyledH1 = styled.h1`
  background: white;
  font-size: ${(props) => props.size ? props.size : '16px'};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => props.color ?? 'black'};
  text-align: center;
  margin: 0;
  padding: 0;
`;

export const StyledH2 = styled.h2`
  background: white;
  font-size: ${(props) => props.size};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  color: ${(props) => props.color ?? 'black'};
  text-align: left;
  margin: 0;
  padding: 0;
`;

export const StyledH4 = styled.h4`

  font-family: ${fontFamily};
  font-size: ${(props) => props.size};
  font-weight: ${(props) => props.fontWeight};
  text-align: top;
  color: ${(props) => props.color ?? 'black'};
  margin: ${(props) => props.margin ?? '0'};
  padding: ${(props) => props.padding ?? '0'};


`

export const StyledButton = styledMUI(Button)({
  color: colorWhite,
  backgroundColor: logoColor3,
  '&:hover': {
    backgroundColor: logoColor3
  },
  padding: 10,
  width: '50ch !important'
});

export const LoginContainerStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 2};

export const LoginFormStyle = {
  '& > :not(style)': { m: 2 },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
};

export const NotificationContainerStyle = {
  p: 1,
  m: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '70ch !important'
};

export const MigrationNotificationStyle = {

  fontFamily,
  p: 1,
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${colorCobalt}`,
  borderRadius: '5px',
  backgroundColor: '#F0F7FF'


}

export const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: 'calc(50% - 200px)',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 3,
  textAlign: 'left'
};

export const AuthTextStyle = { display: 'flex', flexDirection: 'row' };

export const RerouteButtonStyle = {

  px: 2,
  py: 1.5,
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  border: `1px solid ${logoColor3}`,
  borderRadius: '5px',
  backgroundColor: `${colorWhite}`,
  color: `${logoColor3}`,
  fontWeight: 'semibold',
  transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: 4,
    color: `${colorWhite}`,
    backgroundColor: `${logoColor3}`,
    cursor: 'pointer'
  },

}